var i = Object.defineProperty;
var n = (s, e, l) => e in s ? i(s, e, { enumerable: !0, configurable: !0, writable: !0, value: l }) : s[e] = l;
var a = (s, e, l) => n(s, typeof e != "symbol" ? e + "" : e, l);
class r {
  constructor() {
    a(this, "allowedBlocks", ["paragraph", "image", "orderedList", "unorderedList", "heading", "subheading"]);
    a(this, "allowedInline", ["link"]);
    a(this, "tables", {
      responsive: !1,
      containers: !1,
      resizeColumns: !1
    });
    a(this, "templating");
    a(this, "aiPromptData");
    a(this, "singleBlockMode");
  }
}
export {
  r as BaseSchemaConfig
};
